<svg
	xmlns:dc="http://purl.org/dc/elements/1.1/"
	xmlns:cc="http://creativecommons.org/ns#"
	xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
	xmlns:svg="http://www.w3.org/2000/svg"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
	xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
	fill="currentColor"
	height="30px"
	width="30px"
	version="1.1"
	id="Capa_1"
	viewBox="0 0 452.025 452.025"
	xml:space="preserve"
	sodipodi:docname="change_without_return-svgrepo-com.svg"
	inkscape:version="1.0.2-2 (e86c870879, 2021-01-15)"
	><metadata id="metadata52"
		><rdf:RDF
			><cc:Work rdf:about=""
				><dc:format>image/svg+xml</dc:format><dc:type
					rdf:resource="http://purl.org/dc/dcmitype/StillImage"
				/><dc:title /></cc:Work
			></rdf:RDF
		></metadata
	><defs id="defs50" /><sodipodi:namedview
		pagecolor="currentColor"
		bordercolor="currentColor"
		borderopacity="1"
		objecttolerance="10"
		gridtolerance="10"
		guidetolerance="10"
		inkscape:pageopacity="0"
		inkscape:pageshadow="2"
		inkscape:window-width="1048"
		inkscape:window-height="814"
		id="namedview48"
		showgrid="false"
		inkscape:zoom="0.58712223"
		inkscape:cx="597.26402"
		inkscape:cy="468.64448"
		inkscape:window-x="129"
		inkscape:window-y="38"
		inkscape:window-maximized="0"
		inkscape:current-layer="Capa_1"
	/>

	<g id="SVGRepo_bgCarrier" stroke-width="0" />

	<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

	<g id="g42">
		<path
			d="m 147.912,363.325 c -4.7,-4.7 -12.3,-4.7 -17,0 -4.7,4.7 -4.7,12.3 0,17 l 13.6,13.6 h -55.2 c -35.9,0 -65,-29.2 -65,-65 v -40.3 c 0,-6.6 -5.4,-12 -12,-12 -6.6,0 -12,5.4 -12,12 v 40.3 c 0,49.1 39.9,89 89,89 h 55.2 l -13.6,13.6 c -4.7,4.7 -4.7,12.3 0,17 2.3,2.3 5.4,3.5 8.5,3.5 3.1,0 6.1,-1.2 8.5,-3.5 l 34.1,-34.1 c 4.7,-4.7 4.7,-12.3 0,-17 z"
			id="path4"
		/>
		<path
			d="m 210.312,0.025 h -197.1 c -6.6,0 -12,5.4 -12,12 v 197.1 c 0,6.6 5.4,12 12,12 h 197.1 c 6.6,0 12,-5.4 12,-12 v -197.1 c 0,-6.6 -5.3,-12 -12,-12 z m -12,197.1 h -173.1 v -173.1 h 173.1 z"
			id="path6"
		/>
		<path
			d="m 438.812,428.025 c -3.2,0 -6.3,1.3 -8.5,3.5 -2.2,2.2 -3.5,5.3 -3.5,8.5 0,3.1 1.3,6.3 3.5,8.5 2.2,2.2 5.3,3.5 8.5,3.5 3.2,0 6.3,-1.3 8.5,-3.5 2.2,-2.2 3.5,-5.3 3.5,-8.5 0,-3.2 -1.3,-6.3 -3.5,-8.5 -2.3,-2.2 -5.4,-3.5 -8.5,-3.5 z"
			id="path10"
		/>
		<path
			d="m 389.512,428.025 c -6.6,0 -12,5.4 -12,12 0,6.6 5.4,12 12,12 6.6,0 12,-5.4 12,-12 0,-6.6 -5.4,-12 -12,-12 z"
			id="path12"
		/>
		<path
			d="m 290.912,428.025 c -6.6,0 -12,5.4 -12,12 0,6.6 5.4,12 12,12 6.6,0 12,-5.4 12,-12 0,-6.6 -5.3,-12 -12,-12 z"
			id="path14"
		/>
		<path
			d="m 340.212,428.025 c -6.6,0 -12,5.4 -12,12 0,6.6 5.4,12 12,12 6.6,0 12,-5.4 12,-12 0,-6.6 -5.4,-12 -12,-12 z"
			id="path16"
		/>
		<path
			d="m 241.713,428.025 c -3.2,0 -6.3,1.3 -8.5,3.5 -2.2,2.2 -3.5,5.3 -3.5,8.5 0,3.1 1.3,6.3 3.5,8.5 2.2,2.2 5.3,3.5 8.5,3.5 3.1,0 6.3,-1.3 8.5,-3.5 2.2,-2.2 3.5,-5.3 3.5,-8.5 0,-3.2 -1.3,-6.3 -3.5,-8.5 -2.2,-2.2 -5.401,-3.5 -8.5,-3.5 z"
			id="path18"
		/>
		<path
			d="m 241.713,378.725 c -6.6,0 -12,5.4 -12,12 0,6.6 5.4,12 12,12 6.6,0 12,-5.4 12,-12 0,-6.6 -5.401,-12 -12,-12 z"
			id="path20"
		/>
		<path
			d="m 241.713,329.425 c -6.6,0 -12,5.4 -12,12 0,6.6 5.4,12 12,12 6.6,0 12,-5.4 12,-12 0,-6.6 -5.401,-12 -12,-12 z"
			id="path22"
		/>
		<path
			d="m 241.713,280.125 c -6.6,0 -12,5.4 -12,12 0,6.6 5.4,12 12,12 6.6,0 12,-5.4 12,-12 0,-6.6 -5.401,-12 -12,-12 z"
			id="path24"
		/>
		<path
			d="m 241.713,230.925 c -3.2,0 -6.3,1.3 -8.5,3.5 -2.2,2.2 -3.5,5.3 -3.5,8.5 0,3.2 1.3,6.3 3.5,8.5 2.2,2.2 5.3,3.5 8.5,3.5 3.1,0 6.3,-1.3 8.5,-3.5 2.2,-2.2 3.5,-5.3 3.5,-8.5 0,-3.1 -1.3,-6.3 -3.5,-8.5 -2.301,-2.3 -5.401,-3.5 -8.5,-3.5 z"
			id="path26"
		/>
		<path
			d="m 389.512,230.925 c -6.6,0 -12,5.4 -12,12 0,6.6 5.4,12 12,12 6.6,0 12,-5.4 12,-12 0,-6.6 -5.4,-12 -12,-12 z"
			id="path28"
		/>
		<path
			d="m 340.212,230.925 c -6.6,0 -12,5.4 -12,12 0,6.6 5.4,12 12,12 6.6,0 12,-5.4 12,-12 0,-6.6 -5.4,-12 -12,-12 z"
			id="path30"
		/>
		<path
			d="m 290.912,230.925 c -6.6,0 -12,5.4 -12,12 0,6.6 5.4,12 12,12 6.6,0 12,-5.4 12,-12 0,-6.6 -5.3,-12 -12,-12 z"
			id="path32"
		/>
		<path
			d="m 438.812,230.925 c -3.2,0 -6.3,1.3 -8.5,3.5 -2.2,2.2 -3.5,5.3 -3.5,8.5 0,3.2 1.3,6.3 3.5,8.5 2.2,2.2 5.3,3.5 8.5,3.5 3.2,0 6.3,-1.3 8.5,-3.5 2.2,-2.2 3.5,-5.3 3.5,-8.5 0,-3.1 -1.3,-6.3 -3.5,-8.5 -2.3,-2.2 -5.4,-3.5 -8.5,-3.5 z"
			id="path34"
		/>
		<path
			d="m 438.812,280.125 c -6.6,0 -12,5.4 -12,12 0,6.6 5.4,12 12,12 6.6,0 12,-5.4 12,-12 0,-6.6 -5.4,-12 -12,-12 z"
			id="path36"
		/>
		<path
			d="m 438.812,378.725 c -6.6,0 -12,5.4 -12,12 0,6.6 5.4,12 12,12 6.6,0 12,-5.4 12,-12 0,-6.6 -5.4,-12 -12,-12 z"
			id="path38"
		/>
		<path
			d="m 438.812,329.425 c -6.6,0 -12,5.4 -12,12 0,6.6 5.4,12 12,12 6.6,0 12,-5.4 12,-12 0,-6.6 -5.4,-12 -12,-12 z"
			id="path40"
		/>
	</g>
</svg>
